import { Component, input, model } from '@angular/core';

@Component({
  selector: 'yon-pw-button-select',
  imports: [],
  templateUrl: './button-select.component.html',
  styleUrl: './button-select.component.scss'
})
export class ButtonSelectComponent {
  buttons = input<any[]>([]);
  selectedButton = model<any>();
  alignSelf = input<'flex-start' | 'center' | 'flex-end'>('center');

  constructor() {
    
  }

  selectButton(button: any) {
    this.selectedButton.set(button);
  }
}
